// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"9c65a159","626":"3223eff0","651":"3101d167"}[chunkId] + ".chunk.js";
};